import React, {FC} from 'react';
import styled from 'styled-components';

/*
 * Props.
 */

export interface StartGuideProgressBarProps {
  isAdminSetupGuide?: boolean;
  completedSteps: number;
  totalSteps: number;
  hasCompletedAllTasks?: boolean;
}

/*
 * Constants.
 */

const progressBarTransitionDelayInMs = 0;
const progressBarTransitionAnimationInMs = 1000;
export const progressBarTransitionDurationInMs =
  progressBarTransitionDelayInMs + progressBarTransitionAnimationInMs;

/*
 * Style.
 */

const StyledWrapperDiv = styled.div`
  display: grid;
  grid-row-gap: 8px;
  width: 100%;
`;

const StyledBarBackground = styled.div<{$isAdminSetupGuide: boolean}>`
  width: 100%;
  height: ${(p) => (p.$isAdminSetupGuide ? '6px' : '4px')};
  background-color: ${(p) => p.theme.greys.shade30};
  border-radius: 10px;
`;

interface ProgressStyleProps {
  $progress: number;
}
const StyledProgressDiv = styled.div<ProgressStyleProps>`
  width: ${(p) => (p.$progress === 0 ? '8px' : `${p.$progress}%`)};
  height: 100%;
  background-color: ${(p) => p.theme.palette.green.shade40};
  border-radius: 10px;

  transition: ${(progressBarTransitionAnimationInMs / 1000).toFixed(3)}s ease;
  transition-delay: ${(progressBarTransitionDelayInMs / 1000).toFixed(3)}s;
`;

/*
 * Component.
 */

export const StartGuideProgressBar: FC<StartGuideProgressBarProps> = ({
  isAdminSetupGuide,
  completedSteps,
  totalSteps,
}) => {
  const completionPercentage = Math.floor((completedSteps / totalSteps) * 100);

  return (
    <StyledWrapperDiv>
      <StyledBarBackground $isAdminSetupGuide={Boolean(isAdminSetupGuide)}>
        <StyledProgressDiv $progress={completionPercentage} />
      </StyledBarBackground>
    </StyledWrapperDiv>
  );
};
